import { SET_DRAFT_AVOID_AREAS, CLEAR_DRAFT_AVOID_AREAS } from 'actions';

const initialState = null;

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_DRAFT_AVOID_AREAS:
      return { profileIndex: payload.profileIndex, areas: payload.areas };
    case CLEAR_DRAFT_AVOID_AREAS:
      return null;
    default:
      return state;
  }
};
